var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 24 24",
    id: "Design-Magic-Wand--Streamline-Pixel.svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Design Magic Wand Streamline Icon: https://streamlinehq.com")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "design-magic-wand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.61921875 7.66546875h3.2846875000000004v1.0925h-3.2846875000000004Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.71171875 13.14234375h1.0996875v1.0925h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.71171875 2.18859375h1.0996875v1.0925h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.61921875 12.042656249999999h1.0925v1.0996875h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.61921875 3.28109375h1.0925v1.0996875h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.52671875 10.95015625h1.0925v1.0925h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.52671875 4.38078125h1.0925v1.0925h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.04984375 10.95015625 1.0925 0 0 1.0925 1.0996875 0 0 -1.0925 1.0925 0 0 -1.0925 1.0925 0 0 -2.1921874999999997 -1.0925 0 0 -1.0925 -2.1921874999999997 0 0 1.0925 -1.0925 0 0 1.0925 -1.0996875 0 0 1.0996875 1.0996875 0 0 1.0925z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.24203125 1.0960937499999999h1.0925v3.2846875000000004h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.04984375 12.042656249999999h1.0925v1.0996875h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.95015625 13.14234375h1.0996875v1.0925h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.95015625 4.38078125h1.0996875v1.0925h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85765625 14.23484375h1.0925v1.0996875h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85765625 9.85765625h1.0925v1.0925h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85765625 3.28109375h1.0925v1.0996875h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76515625 15.334531250000001h1.0925v1.0925h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76515625 10.95015625h1.0925v1.0925h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76515625 2.18859375h1.0925v1.0925h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66546875 16.42703125h1.0996875v1.0925h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66546875 12.042656249999999h1.0996875v1.0996875h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.572968749999999 17.51953125h1.0925v1.0996875h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.572968749999999 13.14234375h1.0925v1.0925h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48046875 18.61921875h1.0925v1.0925h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48046875 14.23484375h1.0925v1.0996875h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38078125 19.71171875h1.0996875v1.0925h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38078125 15.334531250000001h1.0996875v1.0925h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2882812500000003 16.42703125h1.0925v1.0925h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18859375 20.80421875h2.1921874999999997v1.0996875h-2.1921874999999997Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18859375 17.51953125h1.0996875v1.0996875h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0960937499999999 18.61921875h1.0925v2.185h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.5648bb951b5aa95efbc05ee21c0c26b4.svg";
export { ForwardRef as ReactComponent };